import { NEW_BASE_URL } from "../Constant";
import { newReconGetServiceAPI, newReconServiceAPI } from "./APIutils";

export async function fetchAllCityConfigs({ cityId, agencyId }) {
  const url = agencyId
    ? `${NEW_BASE_URL}/v1/adminPage/getAdminPageConfigs?cityId=${cityId}&agencyId=${agencyId}`
    : `${NEW_BASE_URL}/v1/adminPage/getAdminPageConfigs?cityId=${cityId}`;
  return newReconGetServiceAPI(url);
}

export async function upsertAdminConfig(params) {
  const url = `${NEW_BASE_URL}/v1/adminPage/upsertCityLevelConfig`;
  return newReconServiceAPI(url, { ...params });
}

export async function fetchAgencies({ cityName }) {
  const url = `${NEW_BASE_URL}/v1/adminPage/getAgencies?cityName=${cityName}`;
  return newReconGetServiceAPI(url);
}
